import { useAuth0 } from "@auth0/auth0-react";
import promptStyle from "../prompt.module.css";
import buttonStyle from "../../Common/buttons.module.css"

function LoggedOut() {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className={promptStyle.loneTextWrapper}>
      <h2>
        Please{" "}
        <button onClick={() => loginWithRedirect()} className={buttonStyle.button}>
          log in
        </button>{" "}
        before continuing
      </h2>
    </div>
  );
}

export default LoggedOut;
